import { Button } from 'src/shared/components/ui/buttons/button'

import { ErrorIcon } from '../../icons/error-icon'

const ChatLoadingErrorMessage = ({ error, onRetry }: { error?: Error; onRetry: () => void }) => {
  return (
    <div className="flex size-full flex-1 flex-col items-center justify-center gap-4 overflow-hidden px-10">
      <ErrorIcon className="size-20" />
      <div className="space-y-2">
        <p className="text-center text-[26px] font-semibold text-primary">Chat disconnected</p>
        <p className="text-center text-base font-medium text-muted">
          {error ? error.message : "The messages didn't load as expected. A quick refresh might do the trick!"}
        </p>
      </div>
      <Button className="mt-4 rounded-full" variant="default" size="lg" onClick={onRetry}>
        Refresh messages
      </Button>
    </div>
  )
}

export default ChatLoadingErrorMessage
